import React from 'react';
import { motion } from 'framer-motion';
import { Stars } from 'lucide-react';

const Header = ({ setActiveSection }) => {
  return (
    <header className="bg-black border-b border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <button
            className="flex items-center space-x-3 focus:outline-none group"
            onClick={() => setActiveSection && setActiveSection('habitability-analysis')}
            style={{ background: 'none', border: 'none', padding: 0 }}
          >
            <Stars className="w-6 h-6 text-white group-hover:text-blue-400 transition-colors duration-300" />
            <span className="text-lg font-light text-white tracking-wide group-hover:text-blue-400 transition-colors duration-300" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>Stellar</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 